import React from "react";

export default function TerminiPage() {
  return (
    <div data-testid="termini-page" className="pt-[140px] pb-24">
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <div className="overline mb-6">Documento legale</div>
        <h1 className="font-display text-5xl md:text-6xl tracking-tighter font-medium mb-3">Termini e Condizioni</h1>
        <p className="text-sm text-[#5C5A55] mb-12">Ultimo aggiornamento: Dicembre 2025</p>

        <div className="space-y-8 text-[#1A1918] leading-relaxed">
          <section>
            <h2 className="font-display text-2xl mb-3">1. Premessa</h2>
            <p className="text-[#5C5A55]">
              I presenti termini disciplinano l'uso del sito web di <strong>Koreko Direct</strong>, con sede in Lungomare G. Caboto, 74 — Gaeta (LT). Accedendo al sito accetti integralmente le presenti condizioni.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl mb-3">2. Servizi offerti</h2>
            <p className="text-[#5C5A55]">
              Koreko Direct fornisce informazioni commerciali su infissi, serramenti, vetrate, pergole e impianti fotovoltaici. Il sito non costituisce vendita online: ogni preventivo è non vincolante e soggetto a sopralluogo tecnico.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl mb-3">3. Preventivatore online</h2>
            <p className="text-[#5C5A55]">
              Le stime fornite dal preventivatore sono <strong>orientative</strong>, IVA esclusa, e non rappresentano un'offerta vincolante. Il preventivo definitivo viene rilasciato esclusivamente in seguito a sopralluogo tecnico gratuito e tiene conto delle reali condizioni di posa.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl mb-3">4. Proprietà intellettuale</h2>
            <p className="text-[#5C5A55]">
              Tutti i contenuti del sito (testi, immagini, marchi, logo) sono di proprietà di Koreko Direct o utilizzati con licenza. La riproduzione non autorizzata è vietata.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl mb-3">5. Limitazione di responsabilità</h2>
            <p className="text-[#5C5A55]">
              Koreko Direct non garantisce la disponibilità continua e ininterrotta del sito né l'assenza di errori. Non risponde di eventuali danni derivanti dall'uso o dall'impossibilità di utilizzare il sito.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl mb-3">6. Garanzie sui prodotti</h2>
            <p className="text-[#5C5A55]">
              I prodotti installati godono della garanzia legale di conformità prevista dalla normativa vigente, oltre alle eventuali garanzie convenzionali del produttore (Korus, Gibus e altri partner) e di Koreko Direct sulla posa in opera.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl mb-3">7. Detrazioni fiscali</h2>
            <p className="text-[#5C5A55]">
              L'accesso ai bonus fiscali (Ecobonus, Bonus Casa, ecc.) è soggetto al rispetto dei requisiti di legge. Koreko Direct fornisce supporto burocratico ma non garantisce l'effettiva concessione del beneficio fiscale, che dipende da fattori esterni al fornitore.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl mb-3">8. Legge applicabile</h2>
            <p className="text-[#5C5A55]">
              I presenti termini sono regolati dalla legge italiana. Per ogni controversia è competente il Foro di Latina.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl mb-3">9. Contatti</h2>
            <p className="text-[#5C5A55]">
              Per qualsiasi richiesta scrivi a <a href="mailto:korekodirect@gmail.com" className="text-[#EB0D0D] underline">korekodirect@gmail.com</a> o chiama il +39 347 165 1098.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
